import * as _ from "lodash"

import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {WB_CustomerTypeRow} from "../PA.Core/PAdbSchemaRows";


const vWB_Cust_Fields: { [id: string]: ISearchProviderField } = {
    WB_CUST_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Customer WB Id',
            columnResourceName: 'colCustWBId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Master Data Set WB Id',
            columnResourceName: 'colMDSetId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    CUSTOMER_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Customer Id', columnResourceName: 'colCustId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Customer Name', columnResourceName: 'colCustName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    CUSTOMER_NAME_2: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Customer Name', columnResourceName: 'colCustName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    CUSTOMER_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Type Id', columnResourceName: 'colLevel', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    CUSTOMER_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Type Name', columnResourceName: 'colLevel', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Source', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    KEY_SET: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Key Set', columnResourceName: 'colKeySet', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    ADDRESS: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Street Address', columnResourceName: 'colStreet', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    CITY: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'City', columnResourceName: 'colCity', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    POSTAL_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Postal Code', columnResourceName: 'colZip', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    REGIONAL_MARKET: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Regional Market', columnResourceName: 'colMarket', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    CUSTOMER_CLASSIFICATION: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Customer Classification',
            columnResourceName: 'colClassification',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    ACCOUNT_GROUP: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Account Group',
            columnResourceName: 'colAccountGroup',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    INDUSTRY_CODE1: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Industry Code', columnResourceName: 'colIndustry', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    INDUSTRY_CODE2: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Industry Code (2)',
            columnResourceName: 'colIndustry',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    INDUSTRY_CODE3: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Industry Code (3)',
            columnResourceName: 'colIndustry',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    COMPANY_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Company Code',
            columnResourceName: 'colCompanyCode',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    VAT_LIABLE_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: {columnName: 'VAT Liable', columnResourceName: 'colVATLiable', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    TERRITORY_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: {columnName: 'Territory', columnResourceName: 'colTerritory', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    PAYMENT_BLOCK_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: {
            columnName: 'Payment Block',
            columnResourceName: 'colPaymentBlock',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    ORDER_BLOCK: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Order Block', columnResourceName: 'colOrderBlock', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    BILLING_BLOCK: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Billing Block',
            columnResourceName: 'colBillingBlock',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },
    EXT_DELETION_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: {
            columnName: 'External Deletion Flag',
            columnResourceName: 'colExtDeletion',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 10}
    },

    WB_SALESAREA_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Sales Area',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area Id',
            columnResourceName: 'colSalesAreaId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Area Name',
            columnResourceName: 'colSalesAreaName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'wb Sales Org',
            columnResourceName: 'colSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'SalesOrg Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrgName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },

    MANUAL_IND: {
        type: SearchProviderFieldType.boolean,
        renderOptions: {columnName: 'Manual Flag', columnResourceName: 'colManual', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    }

}

const vWB_Customer_KeyFields =
    {
        id: 'WB_CUST_ID',
        id_ui: 'CUSTOMER_ID',
        name: 'CUSTOMER_NAME'
    }


class CustomerManagerSearchProvider
    implements ISearchProvider {

    _WB_MDSET_ID: number
    _CUSTOMER_TYPE: string
    _Profile: ISearchProfile

    constructor(wbMDSetId: number, customerType: string, profile: ISearchProfile) {
        this._WB_MDSET_ID = wbMDSetId
        this._CUSTOMER_TYPE = customerType
        this._Profile = profile
    }

    get keyFields() { return vWB_Customer_KeyFields }

    get searchProviderFields() { return vWB_Cust_Fields }


    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            requestSpec.where.WB_MDSET_ID = this._WB_MDSET_ID
            requestSpec.where.CUSTOMER_TYPE = this._CUSTOMER_TYPE

            let findRequest = SearchUtils.makeSearchRequest(requestSpec,
                'vUI_Customer_Manager_Search',
                this.searchProviderFields,
            )

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let displayFields: string[] = <string[]>_.uniq(_.concat(this._Profile.profileDisplayFields, Object.values(this.keyFields)))
                    let returnVals: any[] = []
                    _.forEach(res, aRow => {
                        let aVal: { [id: string]: any } = {}
                        _.forEach(displayFields, aField => {
                            aVal[aField] = aRow[aField]

                        })
                        if (!_.filter(returnVals, aRow=>JSON.stringify(aVal)==JSON.stringify(aRow)).length) {
                            returnVals.push(aVal)
                        }
                    })

                    resolve(returnVals)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({
                    where: {
                        WB_MDSET_ID: this._WB_MDSET_ID,
                        CUSTOMER_TYPE: this._CUSTOMER_TYPE
                    }
                },
                'vUI_Customer_Manager_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}

class CustomerManagerSearchProfile
    implements ISearchProfile {

    constructor(wbMDSetId: number, customerTypeId: string, customerTypeRow: WB_CustomerTypeRow) {
        this.wbMasterDataSetId = wbMDSetId
        this.CustomerTypeId = customerTypeId
        this.CustomerTypeRow = customerTypeRow

        this.aSearchProvider = new CustomerManagerSearchProvider(wbMDSetId, customerTypeId, this)
    }

    wbMasterDataSetId: number
    CustomerTypeId: string
    CustomerTypeRow: WB_CustomerTypeRow

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Default Profile"
    renderOptions = {ui5ResourceId: "CustomerManagerSearchProfile"}

    get profileSearchLimit(): number { return  2000 }

    get profileFilter(): IProfileFilter[] {

        let coreFilters: IProfileFilter[] = [
            {profileFilterName: 'Customer Name', searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: {}},
            {profileFilterName: 'Customer ID', searchProviderFieldId: 'CUSTOMER_ID', renderOptions: {}}]

        let salesOrgFilters: IProfileFilter[] = [
            {
                profileFilterName: 'Sales Org',
                searchProviderFieldId: 'SALESORG_NAME',
                bMultiSelect: true,
                renderOptions: {}
            },
            {
                profileFilterName: 'Sales Area',
                searchProviderFieldId: 'SALESAREA_NAME',
                bMultiSelect: true,
                renderOptions: {}
            }]

        let addressFilters: IProfileFilter[] = [
            {profileFilterName: 'Address', searchProviderFieldId: 'ADDRESS', renderOptions: {}},
            {profileFilterName: 'City', searchProviderFieldId: 'CITY', renderOptions: {}},
            {profileFilterName: 'Postal Code', searchProviderFieldId: 'POSTAL_CODE', renderOptions: {}}
        ]

        let attributeFilters: IProfileFilter[] = [
            {profileFilterName: 'Regional Market', searchProviderFieldId: 'REGIONAL_MARKET', renderOptions: {}},
            {profileFilterName: 'Customer Classification', searchProviderFieldId: 'CUSTOMER_CLASSIFICATION', renderOptions: {}},
            {profileFilterName: 'Account Group', searchProviderFieldId: 'ACCOUNT_GROUP', renderOptions: {}},
            {profileFilterName: 'Industry Code', searchProviderFieldId: 'INDUSTRY_CODE1', renderOptions: {}},
            {profileFilterName: 'Source', searchProviderFieldId: 'SOURCE_ID', bMultiSelect: true, renderOptions: {}}
        ]



        if (_.isEmpty(this.CustomerTypeRow))
            return [
                ...coreFilters, ...salesOrgFilters, ...addressFilters, ...attributeFilters
            ]

        let rv = _.clone(coreFilters)
        let ct = this.CustomerTypeRow
        if (ct.bSalesAreaSearchByInd)
            rv = [...rv, ...salesOrgFilters]

        if (ct.bAddressSearchByInd)
            rv = [...rv, ...addressFilters]

        let dctSearchFields = _.keyBy(ct.HeaderSearchFields, (a) => a)
        _.forEach(attributeFilters, (a) => {
            if(a.searchProviderFieldId in dctSearchFields)
                rv.push(a)
        })

        return rv
    }

    get profileDisplayFields(): string[] {

        let coreDisplayFields = [
            "CUSTOMER_ID",
            "CUSTOMER_NAME",
            "KEY_SET",
            "SOURCE_ID"
        ]
        let addressDisplayFields = [
            "ADDRESS",
            "CITY",
            "POSTAL_CODE",
        ]
        let manualIndFields = [
            "MANUAL_IND"
        ]
        let configuredFields = [
            "REGIONAL_MARKET",
            "CUSTOMER_CLASSIFICATION",
            "ACCOUNT_GROUP",
            "INDUSTRY_CODE1",
            "INDUSTRY_CODE2",
            "INDUSTRY_CODE3",
            "VAT_LIABLE_IND",
            "PAYMENT_BLOCK_IND",
            "ORDER_BLOCK",
            "BILLING_BLOCK",
            "EXT_DELETION_IND",
            "TERRITORY_IND",
            "COMPANY_CODE"
        ]

        let unmappedFields = [
            "REGIONAL_MARKET",
            "CUSTOMER_CLASSIFICATION",
            "ACCOUNT_GROUP",
            "INDUSTRY_CODE1",
            "TERRITORY_IND",
            "COMPANY_CODE"
        ]

        if (_.isEmpty(this.CustomerTypeRow))
            return [
                ...coreDisplayFields, ...addressDisplayFields, ...unmappedFields, ...manualIndFields
            ]

        let rv = _.clone(coreDisplayFields)
        let ct = this.CustomerTypeRow
        if (ct.bSalesAreaSearchByInd) {
            //rv = [...rv, ...salesOrgFilters]
        }

        if (ct.bAddressSearchByInd)
            rv = [...rv, ...addressDisplayFields]

        let dctConfiguredFields = _.keyBy(this.CustomerTypeRow.HeaderSearchFields, (a) => a)
        _.forEach(configuredFields, (a) => {
            if (a in dctConfiguredFields)
                rv.push(a)
        })

        return [...rv, ...manualIndFields]
    }

    profileHyperlinkFields = ['CUSTOMER_ID']
    profileSortIdDefault = ""
    profileSorts: ISearchSort[] = []


    get profileSearchProvider() {
        return this.aSearchProvider
    }
}


export class CustomerManagerSearch
    implements ISearch {
    constructor(wbMDSetId: number,
                customerType: string,
                customerTypeRow: WB_CustomerTypeRow,
                options?: any) {

        this.searchProfiles = [new CustomerManagerSearchProfile(wbMDSetId, customerType, customerTypeRow)]
    }

    searchName = "Select Customer(s)"
    renderOptions = {ui5ResourceId: "CustomerManagerSearch"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
